import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Modal, TextField, IconButton, Typography } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';

const AdminSubAdmin = () => {
    const [subAdmins, setSubAdmins] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [assignedLeads, setAssignedLeads] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [currentSubAdmin, setCurrentSubAdmin] = useState(null);
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', password: '' });

    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [teachers, setTeachers] = useState([]);
    const [openStudentModal, setOpenStudentModal] = useState(false);
    const [selectedTeacher, setSelectedTeacher] = useState('');
    const [demoDate, setDemoDate] = useState('');

    // Filter sub-admins based on search query
    const filteredSubAdmins = (subAdmins || []).filter((sa) => {
        const q = searchQuery.toLowerCase();
        return (
            sa?.name?.toLowerCase().includes(q) ||
            sa?.email?.toLowerCase().includes(q) ||
            sa?.phone?.toLowerCase().includes(q) ||
            sa?.subAdminId?.toLowerCase().includes(q)
        );
    });


 

 // Fetch all admins
const fetchSubAdmins = async () => {
    try {
        const response = await axios.get(`/api/admin/all`);
        console.log("Sub Admin",response);
        
        // const data = await response.json();
        setSubAdmins(response.data.subAdmins);
    } catch (error) {
        console.error('Error fetching admins:', error);
    }
};


// Add or Edit admin
const handleSubmit = async (e) => {
    e.preventDefault();

    const url = currentSubAdmin 
        ? `/api/admin/edit/${currentSubAdmin._id}` 
        : '/api/admin/add';
    const method = currentSubAdmin ? 'PUT' : 'POST';

    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });
        const result = await response.json();

        if (response.ok) {
            alert(result.message);
            fetchSubAdmins();
            handleCloseModal();
        } else {
            alert(result.message);
        }
    } catch (error) {
        console.error('Error saving admin:', error);
    }
};

// Delete admin
const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this lead?");
    
    if (!isConfirmed) {
        return; // Stop the function if user cancels
    }
    try {
        const response = await fetch(`/api/admin/delete/${id}`, {
            method: 'DELETE',
        });
        const result = await response.json();

        if (response.ok) {
            alert(result.message);
            fetchSubAdmins();
        } else {
            alert(result.message);
        }
    } catch (error) {
        console.error('Error deleting admin:', error);
    }
};


    useEffect(() => {
        fetchSubAdmins();
        fetchStudents();
        fetchTeachers();
    }, []);
    
    const handleOpenStudentModal = (student) => {
        setSelectedStudent(student);
        setOpenStudentModal(true);
    };
    
    const handleCloseStudentModal = () => {
        setOpenStudentModal(false);
        setSelectedStudent(null);
    };
    
    const handleScheduleDemo = async () => {
        if (!selectedTeacher || !demoDate) {
            alert('Please select a teacher and date');
            return;
        }
    
        // Schedule demo (Replace with your API endpoint)
        await fetch('/api/schedule-demo', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                studentId: selectedStudent.id,
                teacherId: selectedTeacher,
                date: demoDate,
            }),
        });
    
        alert('Demo Scheduled Successfully');
        handleCloseStudentModal();
    };
    
    const fetchStudents = async () => {
        // Fetch student details (Replace with your API endpoint)
        const response = await fetch('/api/students');
        const data = await response.json();
        setStudents(data);
    };
    
    const fetchTeachers = async () => {
        // Fetch teachers list for scheduling demo classes
        const response = await fetch('/api/teachers');
        const data = await response.json();
        setTeachers(data);
    };
    
    // Fetch assigned leads from the backend
    const fetchAssignedLeads = async () => {
        try {
            const response = await fetch('/api/assigned-leads'); // Replace with your API endpoint
            const data = await response.json();
            setAssignedLeads(data);
        } catch (error) {
            console.error('Error fetching assigned leads:', error);
        }
    };

    const handleOpenModal = (subAdmin = null) => {
        setCurrentSubAdmin(subAdmin);
        setFormData(subAdmin ? subAdmin : { name: '', email: '', phone: '', password: '' });
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };




    return (
        <div className='container mt-5'>
            <Button className='mt-3 mb-2' variant="contained" style={{ backgroundColor: "#00a695", color: 'white' }} onClick={() => handleOpenModal()}>
                Add Sub-Admin
            </Button>

            {/* Search Bar */}
            <div style={{ margin: '16px 0', maxWidth: 400 }}>
                <TextField
                    label="Search by name, email, phone or ID"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    InputProps={{
                        endAdornment: searchQuery && (
                            <IconButton size="small" onClick={() => setSearchQuery('')}>
                                ✕
                            </IconButton>
                        ),
                    }}
                />
                {searchQuery && (
                    <Typography variant="body2" style={{ marginTop: 6, color: '#666' }}>
                        {filteredSubAdmins.length} result{filteredSubAdmins.length !== 1 ? 's' : ''} found
                    </Typography>
                )}
            </div>

            <TableContainer component={Paper} className="mb-4">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Sub-Admin ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Password</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredSubAdmins.length > 0 ? (
                            filteredSubAdmins.map((subAdmin, index) => (
                                <TableRow key={subAdmin._id || index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{subAdmin.subAdminId}</TableCell>
                                    <TableCell>{subAdmin.name}</TableCell>
                                    <TableCell>{subAdmin.email}</TableCell>
                                    <TableCell>{subAdmin.phone}</TableCell>
                                    <TableCell>{subAdmin.password}</TableCell>
                                    <TableCell>
                                        <IconButton style={{ color: "#00a695" }} onClick={() => handleOpenModal(subAdmin)}>
                                            <Edit />
                                        </IconButton>
                                        <IconButton style={{ color: "red" }} onClick={() => handleDelete(subAdmin._id)}>
                                            <Delete />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7} style={{ textAlign: 'center', color: '#999', padding: 24 }}>
                                    {searchQuery ? `No sub-admins found for "${searchQuery}"` : 'No sub-admins added yet'}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Modal open={openModal} onClose={handleCloseModal}>
    <Paper style={{ padding: '16px', margin: 'auto', marginTop: '16px', maxWidth: '400px' }}>
        <form onSubmit={handleSubmit}>
            <TextField 
                label="Name" 
                name="name" 
                value={formData.name} 
                onChange={handleChange} 
                fullWidth 
                margin="normal" 
                required 
            />
            <TextField 
                label="Email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                fullWidth 
                margin="normal" 
                required 
            />
            <TextField 
                label="Phone" 
                name="phone" 
                value={formData.phone} 
                onChange={handleChange} 
                fullWidth 
                margin="normal" 
                required 
            />
            <TextField 
                label="Password" 
                name="password" 
                type="password" 
                value={formData.password} 
                onChange={handleChange} 
                fullWidth 
                margin="normal" 
                required 
            />
            <Button type="submit" variant="contained" style={{ backgroundColor: "#00a695", color: "white" }}>
                {currentSubAdmin ? "Update" : "Add"} Sub-Admin
            </Button>
        </form>
    </Paper>
</Modal>


        </div>
    );
};

export default AdminSubAdmin;
